<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      title="Création d'un canal">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <spinner-round
        :is-loading="loading"
        v-if="loading"></spinner-round>
      <div
        v-else
        class="has-background-white is-border">
        <form>
          <div class="is-padding">
            <div class="field">
              <div class="control columns">
                <div class="column is-6 is-padding-left is-padding-right is-padding-top">
                  <r-label
                    :label="'Nom du canal'"
                    :value="canal.name"></r-label>
                  <v-input
                    id="name"
                    name="name"
                    @input="val => canal.name = val"
                    :model="canal.name"
                    data-vv-as="Nom du canal"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val">
                  </v-input>
                </div>
              </div>
            </div>
          </div>
        </form>
        <submit-sticky-buttons
          @submit="submit"
          :loading="submitLoading"
          button-id="canalCreate"></submit-sticky-buttons>
      </div>
    </page-content>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ChannelCreate',
  data () {
    return {
      loading: false,
      canal: {
        name: null
      },
      submitLoading: false
    }
  },
  computed: {
    ...mapState(['currentUser'])
  },
  created () {
  },
  methods: {
    /**
      * submit canal creation
      */
    async submit () {
      this.submitLoading = true
      this.canal.promoteur = this.currentUser.pk
      let canal = Object.assign({}, this.canal)
      const formIsValid = await this.$validator.validateAll()
      if (formIsValid) {
        try {
          await this.$api.post(this.$resources.CHANNELS, canal)
          this.$toasted.global.success('Canal ajouté')
          this.$router.replace({ name: 'ChannelListVue' })
          this.submitLoading = false
        } catch (e) {
          console.log(e)
          this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
          this.submitLoading = false
        }
      }
    }
  }
}
</script>
